var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 47,
    viewBox: "0 0 46 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Bell_Icon_UIA"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon awesome-bell",
    d: "M40.9696 32.2718C39.3584 30.5498 36.3423 27.9596 36.3423 19.4756C36.3452 16.431 35.2805 13.4806 33.3316 11.1319C31.3826 8.78333 28.6712 7.18339 25.6637 6.60738V4.87943C25.6637 4.53092 25.5947 4.18583 25.4605 3.86385C25.3264 3.54187 25.1297 3.24931 24.8818 3.00288C24.6339 2.75645 24.3396 2.56097 24.0157 2.4276C23.6918 2.29423 23.3447 2.22559 22.9941 2.22559C22.6435 2.22559 22.2964 2.29423 21.9725 2.4276C21.6486 2.56097 21.3543 2.75645 21.1064 3.00288C20.8585 3.24931 20.6619 3.54187 20.5277 3.86385C20.3935 4.18583 20.3245 4.53092 20.3245 4.87943V6.60738C17.3171 7.18339 14.6056 8.78333 12.6567 11.1319C10.7077 13.4806 9.64307 16.431 9.64595 19.4756C9.64595 27.9596 6.62986 30.5498 5.01859 32.2718C4.559 32.7591 4.30613 33.4038 4.31262 34.0717C4.31293 34.4208 4.38247 34.7665 4.51726 35.0889C4.65205 35.4112 4.84945 35.704 5.09817 35.9505C5.34689 36.197 5.64204 36.3923 5.96675 36.5253C6.29147 36.6583 6.63937 36.7264 6.99056 36.7256H39.0095C39.3607 36.7264 39.7086 36.6583 40.0333 36.5253C40.358 36.3923 40.6532 36.197 40.9019 35.9505C41.1506 35.704 41.348 35.4112 41.4828 35.0889C41.6176 34.7665 41.6872 34.4208 41.6875 34.0717C41.6908 33.4022 41.4336 32.7573 40.9696 32.2718Z",
    stroke: "#FF8C69",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 3317",
    d: "M21.125 4.66211H24.875V6.1505L23.9951 7.11836H23H22.0049L21.125 6.1505V4.66211Z",
    fill: "#FF8C69",
    stroke: "#FF8C69",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 186"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1_23384_57713",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.75 40.75C28.75 42.275 28.1442 43.7375 27.0659 44.8159C25.9875 45.8942 24.525 46.5 23 46.5C21.475 46.5 20.0125 45.8942 18.9341 44.8159C17.8558 43.7375 17.25 42.275 17.25 40.75L23 40.75H28.75Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M28.75 40.75C28.75 42.275 28.1442 43.7375 27.0659 44.8159C25.9875 45.8942 24.525 46.5 23 46.5C21.475 46.5 20.0125 45.8942 18.9341 44.8159C17.8558 43.7375 17.25 42.275 17.25 40.75L23 40.75H28.75Z",
    fill: "#FF8C69",
    stroke: "#FF8C69",
    strokeWidth: 4,
    mask: "url(#path-3-inside-1_23384_57713)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.2e1468b2099c993e3dcd07ffa507346d.svg";
export { ForwardRef as ReactComponent };